import * as THREE from "three";
import {ModelLoader} from "./loader";
import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader";
import {DRACOLoader} from "three/examples/jsm/loaders/DRACOLoader";

export class GLBModelLoader extends ModelLoader {

    defaultAnimations = [];

    boneNameCorrectionMap = {
        "Hips": "mixamorig1Hips",
        "Spine": "mixamorig1Spine",
        "Spine1": "mixamorig1Spine1",
        "Spine2": "mixamorig1Spine2",
        "Neck": "mixamorig1Neck",
        "Head": "mixamorig1Head",
        "LeftShoulder": "mixamorig1LeftShoulder",
        "LeftArm": "mixamorig1LeftArm",
        "LeftForeArm": "mixamorig1LeftForeArm",
        "LeftHand": "mixamorig1LeftHand",
        "RightShoulder": "mixamorig1RightShoulder",
        "RightArm": "mixamorig1RightArm",
        "RightForeArm": "mixamorig1RightForeArm",
        "RightHand": "mixamorig1RightHand",
        "LeftUpLeg": "mixamorig1LeftUpLeg",
        "LeftLeg": "mixamorig1LeftLeg",
        "LeftFoot": "mixamorig1LeftFoot",
        "LeftToeBase": "mixamorig1LeftToeBase",
        "LeftToeEnd": "mixamorig1LeftToe_End",
        "LeftToe_End": "mixamorig1LeftToe_End",
        "RightUpLeg": "mixamorig1RightUpLeg",
        "RightLeg": "mixamorig1RightLeg",
        "RightFoot": "mixamorig1RightFoot",
        "RightToeBase": "mixamorig1RightToeBase",
        "RightToeEnd": "mixamorig1RightToe_End",
        "RightToe_End": "mixamorig1RightToe_End",
    }

    constructor() {
        super();
        this.loader = new GLTFLoader();
        this.initDraco();
    }

    initDraco() {
        this.draco = new DRACOLoader();
        this.draco.setDecoderConfig({type: 'js'});
        // Specify path to a folder containing WASM/JS decoding libraries.
        this.draco.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');
        // Optional: Pre-fetch Draco WASM/JS module.
        this.draco.preload();
        this.loader.setDRACOLoader(this.draco);
    }

    onLoad(gltf, callback) {
        const animationsMap = {}
        const scene = this.handleArmature(gltf.scene)
        // const scene = gltf.scene

        const gltfAnimations = [...gltf.animations, ...scene.animations] //Join animations if needed?
        // console.log("GLB::onLoad", scene, gltfAnimations)

        callback(scene, {
            animations: gltfAnimations,
            animationMap: animationsMap
        })
    }

    /**
     * Armature is annoying so we have to set pose or it all compresses
     * TODO check if we also need to bind to skele
     * @param scene
     * @returns {*}
     */
    handleArmature(scene) {
        if (scene.children[0].name !== "Armature")
            return scene

        // console.log("Default animations: ", this.defaultAnimations, scene)
        if (!scene.animations || scene.animations.length <= 0) {
            console.log("No animations found, using default", this.defaultAnimations)
            scene.animations = this.defaultAnimations
        }
        return scene
    }

    setDefaultAnimations(animations) {
        if (animations.length <= 0)
            return

        // console.log("Setting default animations", animations)
        this.defaultAnimations = animations
    }
}